<!-- Race selection -->
<div
  class="
    race-selection-section
    races-paginate
    tw-relative
  "
>
  <div class="
    tw-flex
    tw-items-center
    tw-mt-[5px]
    tw-pl-[6px]
  ">
    <div
      #swipeRaceSectionTemplateRef
      class="current-races tw-w-[465px]"
      data-cy="race-numbers"
    >

      @if (selectedRace !== undefined) {
        <span
          class="tw-cursor-pointer"
          [class.prev-paginate]="race?.RaceStatus === 3"
          [class.active-paginate]="selectedRace.RaceId === race?.RaceId"
          (click)="selectRace($event, race)"
          *ngFor="let race of (selectedEvent?.ToteResponse?.EventDetail?.Races)"
          [attr.data-cy]="'wager-race-number-' + race.RaceId"
        >
          {{ race?.RaceId }}
        </span>
      }
    </div>
  </div>
</div>
